import type { DependencyContainer } from 'tsyringe';

import { PermissionsRouteGuard } from './use-cases/route-guard';

export function installPermissionsRouteGuard(container: DependencyContainer) {
    const routeGuard = container.resolve(PermissionsRouteGuard);
    routeGuard.install();
}
